import React, { useState } from 'react';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { 
  LayoutDashboard, 
  Package, 
  MessageSquare, 
  Image, 
  LogOut,
  Menu,
  X
} from 'lucide-react';
import { Button } from '../../components/ui/button';

const AdminLayout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuAberto, setMenuAberto] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const menuItems = [
    { nome: 'Dashboard', path: '/admin/dashboard', icon: LayoutDashboard },
    { nome: 'Produtos', path: '/admin/produtos', icon: Package },
    { nome: 'Feedbacks', path: '/admin/feedbacks', icon: MessageSquare },
    { nome: 'Galeria', path: '/admin/galeria', icon: Image }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className={`admin-sidebar ${menuAberto ? 'open' : ''}`}>
        <div className="admin-sidebar-header">
          <h2>Mordida de Sonho</h2>
          <p>Painel Admin</p>
        </div>

        <nav className="admin-sidebar-nav">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`admin-nav-item ${isActive(item.path) ? 'active' : ''}`}
                onClick={() => setMenuAberto(false)}
              >
                <Icon size={20} />
                <span>{item.nome}</span>
              </Link>
            );
          })}
        </nav>

        <div className="admin-sidebar-footer">
          <Button onClick={handleLogout} variant="outline" className="logout-btn">
            <LogOut size={20} />
            <span>Sair</span>
          </Button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="admin-main">
        <header className="admin-header">
          <button 
            className="admin-menu-toggle"
            onClick={() => setMenuAberto(!menuAberto)}
          >
            {menuAberto ? <X size={24} /> : <Menu size={24} />}
          </button>
          <h1>Painel Administrativo</h1>
        </header>

        <main className="admin-content">
          <Outlet />
        </main>
      </div>

      {/* Overlay para mobile */}
      {menuAberto && (
        <div 
          className="admin-overlay"
          onClick={() => setMenuAberto(false)}
        />
      )}
    </div>
  );
};

export default AdminLayout;
